import { Trans } from '@lingui/react/macro'

export default function FootNote({ showServiceFilters = true }) {
  return (
    <div className='footnotes'>
      <p className='small mt-4 pt-4 border-top border-light-subtle'>
        <Trans>UTC time is considered in all of the charts.</Trans>
      </p>
      {showServiceFilters && (
        <div className='small mt-4 pt-4 border-top border-light-subtle'>
          <Trans>The service filters for the Daily Costs Charts are applicable only to the following services:</Trans>
          <li>
            <Trans>Amazon Elastic Compute Cloud (EC2) - Compute EC2 - Other</Trans>
          </li>
          <li>
            <Trans>Amazon Relational Database Service (RDS)</Trans>
          </li>
          <li>
            <Trans>Amazon Simple Storage Service (S3)</Trans>
          </li>
          <li>
            <Trans>AWS Cost Explorer</Trans>
          </li>
          <li>
            <Trans>Amazon Elastic Container Service</Trans>
          </li>
        </div>
      )}
      <p className='small mt-4 pt-4 border-top border-light-subtle'>
        <Trans>
          * To ensure uniformity across the charts, the data imported is consistently set to a three-day delay (D-3).
        </Trans>
      </p>
    </div>
  )
}
